import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'filter',
})
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items: any[], fields: string[], value: any): any[] {
    if (!items) {
      return [];
    }
    if (items.length === 0) {
      return [];
    }
    if (fields.length === 0 || value === undefined || value === null || value === 'null' || value === '') {
      return items;
    }

    return items.filter((singleItem) => {
      let item: false;
      fields.forEach((x) => {
        if (!item) {
          const objects = x.split('.');
          let object = singleItem;
          objects.forEach((element, index) => {
            if (object != null) {
              object = object[element];
              if (objects.length === index + 1 && object !== undefined && object != null) {
                if (
                  !isNaN(Date.parse(object)) &&
                  typeof object !== 'number' &&
                  element !== 'address' &&
                  element !== 'vehicle' &&
                  element !== 'contractName' &&
                  element !== 'assetName' &&
                  element !== 'alias' &&
                  element !== 'alertStatusValue'
                ) {
                  const tempDate = object.replace(/-/g, '/');
                  item = tempDate.includes(value.toString().toLowerCase());
                } else {
                  item = this.removeAccents(object.toString().toLowerCase()).includes(value.toString().toLowerCase());
                }
              }
            }
          });
        }
      });
      return item;
    });
  }

  removeAccents = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };
}
